import React, { useRef } from 'react';
import { useDebouncedCallback } from '@mantine/hooks';
import cs from 'classnames';
import { useScrollTop } from '../../../hooks/useScrollTop';
const ScrollListener = ({ children, className, onScroll, bottomDistance = 120, debounceTime = 200 }) => {
  const scrollRef = useRef(null);
  const { scroll } = useScrollTop(scrollRef);
  const handleScroll = useDebouncedCallback(() => {
    const { scrollHeight, clientHeight, scrollTop } = scrollRef.current;
    if (scrollHeight - clientHeight <= scrollTop + bottomDistance) {
      // 根据实际情况来调整触底高度
      onScroll?.();
    }
    scroll(); // 触顶
  }, debounceTime);

  return (
    <div ref={scrollRef} onScroll={handleScroll} className={cs('h-full overflow-auto', className)}>
      {children}
    </div>
  );
};
export default ScrollListener;
